<script setup>
import NotificationDot from '@/components/BaseComponents/icons/NotificationDot.vue';
const {color, notification} = defineProps({
  color: {
    type: String,
  },
  notification: {
    type: Boolean
  }
})
</script>

<template>
  <g>
    <path
        d="M9.33333 20.0909C10.041 20.6562 10.9755 21 12 21C13.0245 21 13.959 20.6562 14.6667 20.0909M4.50763 17.1818C4.08602 17.1818 3.85054 16.5194 4.10557 16.1514C4.69736 15.2975 5.26855 14.0451 5.26855 12.537L5.29296 10.3517C5.29296 6.29145 8.29581 3 12 3C15.7588 3 18.8058 6.33993 18.8058 10.4599L18.7814 12.537C18.7814 14.0555 19.3329 15.3147 19.9006 16.169C20.1458 16.5379 19.9097 17.1818 19.4933 17.1818H4.50763Z"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
    </path>
    <notification-dot v-if="notification"></notification-dot>
  </g>
</template>